import {useEffect, useRef} from 'react';

import {getBrowserPerformanceContext} from '../../../util/datadog/browserPerformanceContext';
import {recordRumDurationVital} from '../../../util/datadog/datadogRum';
import {type UPlotPreparationMeasurement} from './prepareUPlotData';

/** Publish a sampled preparation after the panel commits, once for its shared data. */
export function useUPlotPreparationProfile(
  panelId: string,
  measurement: UPlotPreparationMeasurement | undefined,
  yLogScale: boolean,
  width: number | undefined,
  height: number | undefined
) {
  const reported = useRef<
    {panelId: string; measurement: UPlotPreparationMeasurement} | undefined
  >(undefined);
  useEffect(() => {
    if (
      !panelId ||
      measurement == null ||
      (reported.current?.measurement === measurement &&
        reported.current.panelId === panelId)
    ) {
      return;
    }
    reported.current = {panelId, measurement};
    try {
      recordRumDurationVital('workspace.func_perf.prepareUPlotData', {
        startTime: measurement.startTime,
        duration: measurement.duration,
        description: 'prepare chart lines and min/max bands for uPlot',
        context: {
          ...measurement.context,
          ...getBrowserPerformanceContext(),
          panelId,
          yLogScale,
          width,
          height,
        },
      });
    } catch {
      // RUM delivery is best-effort and must not break the committed chart.
    }
  }, [panelId, measurement, yLogScale, width, height]);
}
